import { createSlice } from "@reduxjs/toolkit";

const intialCompanyUsersState = {
  companyUsers: {
    count: 0,
    list: [],
    loading: false,
    errorMessage: null,
  },
};

const companyUsers = createSlice({
  name: "companyUsers",
  initialState: intialCompanyUsersState,
  reducers: {
    getCompanyUsersRequest(state) {
      state.companyUsers.loading = true;
    },
    getCompanyUsersSuccess(state, action) {
      state.companyUsers.list = action.payload.data;
      state.companyUsers.count = action.payload.count;
      state.companyUsers.errorMessage = "";
      state.companyUsers.loading = false;
    },
    getCompanyUsersFailed(state, action) {
      state.companyUsers.list = [];
      state.companyUsers.count = 0;
      state.companyUsers.errorMessage = action.payload.errorMessage;
      state.companyUsers.loading = false;
    },
  },
});
export const compnayUsersAction = companyUsers.actions;
export default companyUsers.reducer;
